/**
 * Utility function to download a PDF file from a buffer.
 * This function creates a Blob from the provided buffer, generates a URL for it,
 * creates a temporary anchor element to trigger the download,
 * and then cleans up the URL after the download is initiated.
 * * @param {ArrayBuffer} buffer - The PDF data as an ArrayBuffer.
 * @param {string} filename - The name of the file to be downloaded.
 * @throws {Error} Throws an error if the buffer is not provided or is not an ArrayBuffer,
 *                 or if the buffer is empty.
 */
export function downloadPdfFromBuffer(buffer, filename) {
  // Accept ArrayBuffer, Uint8Array, or array-like objects (plain arrays)
  let pdfBuffer;
  if (buffer instanceof ArrayBuffer) {
    pdfBuffer = new Uint8Array(buffer);
  } else if (buffer instanceof Uint8Array) {
    pdfBuffer = buffer;
  } else if (Array.isArray(buffer)) {
    pdfBuffer = new Uint8Array(buffer);
  } else {
    throw new Error('No content received from the server');
  }
  if (!pdfBuffer.length) throw new Error('Received empty PDF buffer');
  const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link); // Required for Firefox
  link.click(); // Programmatically trigger the download
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}